module.exports = __webpack_public_path__ + "static/media/Roboto-Medium.9a3bf7ac.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Medium.woff
// module id = 526
// module chunks = 0